module.exports = __webpack_public_path__ + "img/20190612_132334_028.590d4138.jpg";